import { ChatContext } from '..'
import { ChatWsContext } from '..'
import { Send } from 'react-feather'
import { CardMessage } from "../card/CardMessage"
import Avatar from '../../avatar'
import background from "../../../../assets/images/pages/chat-image.jpg"
import Form from 'reactstrap/lib/Form'

import React, {
    useContext,
    useEffect,
    useState
} from 'react'

import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Input,
    InputGroup,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap'

import {
    MoreVertical,
    MessageSquare,
    Menu,
    X,
    File,
} from 'react-feather'

// API
import {
    getMessageByRoom,
    uploadFileMessage
} from '../../../../services/pages/chat/messageChat'

import {
    removeMember,
    markAsRead,
} from '../../../../services/pages/chat/roomChat'

import { fallbackImage_ } from '../../../../helpers/default_helper'

const ChatMessage = (props) => {

    // let uuid = "9528f415-bc15-404c-a878-3c5e74e4f8a0"

    // STATE
    const [inputText, setInputText] = useState("")

    // CONTEXT
    const {
        changeVisibilityContact,
        changeVisibilityGroupInformation
    } = useContext(ChatContext)

    const {
        uuid,
        activeRoom, setActiveRoom,
        messageByRoom, setMessageByRoom,
        sendForwardMessage, setSendForwardMessage,
        setDetailActiveRoom,
        selectedMessage,
        setSelectedMessage,
        connectSocket,
        createNewMessage,
        endConversation,
        archiveConversation,
        handleSetListMember,
        forwardMessage, setForwardMessage,
        roomByUUID, setRoomByUUID,
        roomArchiveByUUID, setRoomArchiveByUUID,
    } = useContext(ChatWsContext)

    useEffect(() => {
        if (activeRoom !== null) {
            if (activeRoom.id !== undefined) {
                connectSocket(activeRoom.id)
                getMessageByRoom(activeRoom.id)
                    .then((response) => {
                        response.data.messages !== undefined ? setMessageByRoom(response.data.messages) : setMessageByRoom([])
                        setDetailActiveRoom(response.data)
                        handleSetListMember(response)
                    })
            }
        }
    }, [activeRoom])

    useEffect(() => {
        if (sendForwardMessage) {
            let messageID = forwardMessage === null ? "" : forwardMessage.id
            if (messageID !== "") {
                createNewMessage("forward", messageID, "", [])
                setForwardMessage(null)
                setSendForwardMessage(false)
            }
        }

    }, [sendForwardMessage])

    const handleSendMessage = (e) => {
        e.preventDefault()
        setInputText("")
        let parentID = selectedMessage === null ? "" : selectedMessage.id
        if (inputText !== "") {
            createNewMessage("text", inputText, parentID, [])
            setSelectedMessage(null)
        }
    }

    const handleUploadFile = (file) => {
        const data = new FormData()
        data.append("attachment[]", file)

        uploadFileMessage(data)
            .then((response) => {
                let parentID = selectedMessage === null ? "" : selectedMessage.id
                let attachmentList = []
                response.data.map(item => {
                    attachmentList.push(item.id)
                })
                createNewMessage("text", inputText, parentID, attachmentList)
            })
    }

    function handleRemoveMember(uuid, room_id) {
        removeMember([uuid], room_id)
            .then((response) => {
                let newList = roomByUUID.filter(item => item.id !== response.data.id)
                setRoomByUUID(newList)
                let newListArchive = roomArchiveByUUID.filter(item => item.id !== response.data.id)
                setRoomArchiveByUUID(newListArchive)

                setActiveRoom(null)
            })
    }

    function handleMarkAsRead(id) {
        markAsRead(id)
            .then((response) => {
            })
    }

    useEffect(() => {
        if (activeRoom !== null) {
            handleMarkAsRead(activeRoom.id)
        }
    }, [activeRoom])

    const renderMessage = () => {
        return (
            messageByRoom !== undefined ? (
                messageByRoom.map((message, index) => {
                    let currentSender = index !== 0 ? messageByRoom[index - 1].sender_id : messageByRoom.sender_id

                    return (
                        message !== undefined ? (
                            message.room_id === activeRoom.id ? (
                                <CardMessage key={message.id} message={message} currentSender={currentSender} />
                            ) : null
                        ) : null
                    )
                })
            ) : null
        )
    }

    return (
        <>
            {
                activeRoom !== null ? (
                    <Card style={{ height: '100%' }} className='shadow chat-app-window'>
                        <CardHeader className="p-1 bg-white border-bottom" style={{ height: '110px' }}>
                            <UncontrolledDropdown className="align-self-center col-12">
                                <div className='d-flex justify-content-between bg-white col-12'>
                                    <div className='d-block d-lg-none align-self-center' onClick={() => changeVisibilityContact()}>
                                        <Menu size={21} className='cursor-pointer m-0' />
                                    </div>
                                    <div className='align-self-center '>
                                        <Avatar onError={fallbackImage_} img={activeRoom.avatar} style={{ marginRight: 10 }} />
                                        <strong className='text-uppercase'>
                                            {activeRoom.name}
                                        </strong>
                                    </div>
                                    <DropdownToggle tag='span' >
                                        <MoreVertical size={21} className='cursor-pointer' />
                                    </DropdownToggle>
                                </div>
                                <DropdownMenu direction='end' className="mr-5">
                                    {
                                        activeRoom.type === "group" ? (
                                            <>
                                                <DropdownItem className='w-100' onClick={() => changeVisibilityGroupInformation(true)}>
                                                    <span className='align-middle'>Informasi Grup</span>
                                                </DropdownItem>
                                                <DropdownItem className='w-100' onClick={() => handleRemoveMember(uuid, activeRoom.id)}>
                                                    <span className='align-middle'>Keluar dari Grup</span>
                                                </DropdownItem>
                                            </>
                                        ) : null
                                    }
                                    <DropdownItem className='w-100' onClick={() => { endConversation(activeRoom.id); setActiveRoom(null) }}>
                                        <span className='align-middle'>Hapus Percakapan</span>
                                    </DropdownItem>
                                    <DropdownItem className='w-100' onClick={() => { archiveConversation(activeRoom.id); setActiveRoom(null) }}>
                                        <span className='align-middle'>Arsipkan Percakapan</span>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </CardHeader>

                        <CardBody className="p-0 bg-dark"
                            style={{ background: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),url("${background}")`, }}
                        >
                            <div className='user-chats2 m-0 p-0 h-100' style={{ overflow: 'auto' }}>
                                {
                                    messageByRoom !== undefined ? (
                                        <div className='chats p-2'>
                                            {renderMessage()}
                                        </div>
                                    ) : (
                                        <div style={{ height: '100%' }} className="">
                                            <div className="d-flex text-center rounded" style={{ height: '100%' }}>
                                                <Button className="m-0 m-auto btn-primary p-1 rounded text-white" color="primary" onClick={() => changeVisibilityContact()}>
                                                    <MessageSquare size={30} className='mr-1' />
                                                    <strong> Percakapan Kosong </strong>
                                                </Button>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </CardBody>

                        <CardFooter>
                            {
                                selectedMessage !== null ? (
                                    <Card className="p-0 bg-light">
                                        <CardBody className="p-1">
                                            <div className='d-flex justify-content-between'>
                                                <div className='d-inline-block'>
                                                    <strong>
                                                        {selectedMessage.sender.name}
                                                    </strong>
                                                    <br />
                                                    <div className='text-muted'>
                                                        {selectedMessage.content}
                                                    </div>
                                                </div>
                                                <div>
                                                    <Button className="rounded-circle p-0" style={{ width: '30px', height: '30px' }}
                                                        onClick={() => setSelectedMessage(null)}
                                                    >
                                                        <X size={14} />
                                                    </Button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                ) : null
                            }
                            <Form onSubmit={(e) => handleSendMessage(e)}>
                                <InputGroup className="input-group-merge me-1 form-send-message">
                                    <label htmlFor='upload_file' className='bg-primary rounded m-0 cursor-pointer'
                                        style={{ height: '45px' }}
                                    >
                                        <File size={18} className='p-0 m-1 text-white' />
                                    </label>
                                    <Input
                                        id="upload_file"
                                        type="file"
                                        className="btn btn-primary btn-sm d-none"
                                        onChange={(event) => handleUploadFile(event.target.files[0])}
                                    />
                                    <Input
                                        placeholder="Tulis Pesan..."
                                        type="text"
                                        value={inputText}
                                        style={{ height: '45px' }}
                                        className="ml-1 border p-1"
                                        onChange={(event) => setInputText(event.target.value)}
                                    />
                                    <Button color='primary' size="sm" >
                                        <Send size={14} className='d-lg-none' />
                                        <span className='d-none d-lg-block'>Kirim</span>
                                    </Button>
                                </InputGroup>
                            </Form>
                        </CardFooter>

                    </Card>
                ) : (
                    <Card style={{ height: '100%' }}>
                        <CardBody className="p-2" style={{ background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url("${background}")`, }}>
                            <div className="d-flex text-center bg-white rounded" style={{ height: '100%' }}>
                                <Button className="m-0 m-auto d-lg-none d-md-block" color="primary" onClick={() => changeVisibilityContact()}>
                                    <MessageSquare size={30} className='mr-1' />
                                    <strong>
                                        Mulai Percakapan!
                                    </strong>
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                )
            }
        </>
    )
}

export default ChatMessage;